/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.free[_ngcontent-%COMP%]{color:#ff4365;text-decoration:line-through;margin-left:5px}"];
export { styles as styles };
